import axios from 'axios'
const header = {
//   'x-api-key': process.env.REACT_APP_BASE_URL_DOCUMENT_PROCESSING
}
export default axios.create({
  baseURL: process.env.REACT_APP_BASE_URL_DOCUMENT_PROCESSING,
  headers: { ...header }
})